<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />
    <breadcrumb class="breadcrumb-container"/>
    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!-- <error-log class="errLog-container right-menu-item"/> -->
        <el-tooltip :content="$t('navbar.screenfull')" effect="dark" placement="bottom">
          <screenfull class="screenfull right-menu-item"/>
        </el-tooltip>
        <lang-select class="international right-menu-item"/>
        <el-tooltip :content="$t('navbar.theme')" effect="dark" placement="bottom">
          <theme-picker class="theme-switch right-menu-item"/>
        </el-tooltip>
      </template>
      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="avatar" :src="url_+avatar" class="user-avatar">
          <i class="el-icon-caret-bottom"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>{{ $t('navbar.dashboard') }}</el-dropdown-item>
          </router-link>
          <el-dropdown-item>
            <span @click="changepassword">{{ $t('table.changePwd') }}</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="roles.RoleId === 3">
            <span @click="changeFieldPwd">修改场地密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <editpwd ref="mychild" :date="edituser"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { qryUserInfo } from '@/api/user'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
import LangSelect from '@/components/LangSelect'
import ThemePicker from '@/components/ThemePicker'
import editpwd from '@/views/userManages/editpwd'
import { updateFieldUserDevPassword } from '@/api/user'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    editpwd,
    // SizeSelect,
    LangSelect,
    ThemePicker
  },
  data() {
    return {
      url_: process.env.BASE_API,
      avatar: null,
      edituser: {
        userId: '',
        pwd: '',
        editshow: false
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'device', 'roles'])
  },
  created() {
    const query_ = {
      userId: this.$store.getters.roles.UserId
    }
    qryUserInfo(query_).then(response => {
      this.avatar = response.LsList[0].Avatar || '/static/default.jpg'
    })
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      location.reload()
    },
    changepassword() {
      this.$refs.mychild.openedit(this.$store.getters.roles.UserId)
      // this.$prompt("请输入新密码(6-20位字母加数字组合)", "修改密码", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPattern: /^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,20}$/,
      //   inputErrorMessage: "密码格式不正确"
      // })
      //   .then(({ value }) => {
      //     const pwdobj = {
      //       userId: this.$store.getters.roles.UserId,
      //       pwd: value
      //     };
      //     UpdatePassWord(pwdobj).then(response => {
      //       location.reload();
      //     });
      //   })
      //   .catch(() => {});
    },
    changeFieldPwd() {
      this.$prompt('请输入场地密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\w{6,}$/,
        inputErrorMessage: '场地密码格式不正确, 密码长度最少6位',
        inputPlaceholder: '请输入需要重置的场地设备登录密码'
      }).then(({ value }) => {
        updateFieldUserDevPassword({ userId: this.$store.getters.roles.UserId, devPwd: value }).then(res => {
          if (res) {
            this.$notify({
              type: 'success',
              title: '成功',
              message: '场地设备登录密码修改成功'
            })
            this.getList()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
